import { Component, OnInit } from '@angular/core';
import { ManageTemplateWrapper } from './manage-template-wrapper';
import { assetTemplateReselector, exhibitorTemplateReselector } from '../../store/reselectors/entity.reselector';
import { Asset, assetIconList, assetIconToName } from 'globals/store/assets.data';
import { IconDialogComponent, IconDialogData } from '../../modules/assets/icon.dialog.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { ManageContactDetailsComponent } from 'src/app/modules/manage/manage-contact-details.component';
import { ManageSocialLinksComponent } from 'src/app/modules/manage/manage-social.component';
import { JoiInputComponent } from '../joi-input/joi-input.component';
import { CommonModule } from '@angular/common';
import { ManageWrapperComponent } from 'src/app/modules/manage/manage-wrapper.component';
import { MenuHoverButtonComponent } from '../buttons/menu-hover-button.component';
import { TitleIconComponent } from '../icon/title-icon.component';

@Component({
    selector: 'manage-template-asset',
    templateUrl: './manage-template-asset.html',
    styleUrls: ['../../modules/manage/manage-dialogs.scss'],
    standalone: true,
    imports: [ManageWrapperComponent, CommonModule, JoiInputComponent, MenuHoverButtonComponent, TitleIconComponent],
})
export class ManageTemplateAsset extends ManageTemplateWrapper<Asset> implements OnInit {
  _file = 'manage-template-asset'
  readOnly = false

  ngOnInit() {
    this.clipboardKey = 'assets'
    this.selectProp(assetTemplateReselector, { id: this.data.entityId, accountId: this.data.accountId }, 'entity')
  }

  async setIcon() {
    const rect = document.getElementById('iconButton').getBoundingClientRect()
    const data: IconDialogData = { selectedIconId: this.entity.icon, rect, iconChoices: assetIconList, nameMap: assetIconToName }
    await openDialogGetResult(this.dialog, IconDialogComponent, { width: '300px', autoFocus: false, backdropClass: 'clear', data })
    if ((!data.selectedIconId && !this.entity.icon ) || data.selectedIconId === this.entity.icon) return
    this.entity.icon = data.selectedIconId
    this.saveEntity()
  }


}
